<template>
  <div class="breakdown builder-page" :class="{ 'justify-center': !haveData }">
    <spinner
      v-if="localLoading"
      width="100"
      height="100"
    />
    <template v-else>
      <template v-if="haveData">
        <div class="l-flex-row chart-container">
          <div style="width: 25%">
            <p class="no-breakdown" v-if="topClusters.length == 0">
              No cluster available
            </p>
            <div v-else class="breakdown-section">
              <div class="l-flex-row--between">
                <p class="block-header">
                  Clusters
                </p>
                <el-radio-group v-model="clusterOrder" name="devicedisplay" size="mini">
                  <el-radio-button
                    v-for="(option, i) in [{ label: 'asc', value: 'asc' }, { label: 'desc', value: 'desc' }]"
                    :key="i"
                    name="clusterOrder"
                    class="btn-radio cluster-sort"
                    :label="option.value"
                    :value="option.value"
                  >
                    <svg-icon v-show="option.label === 'desc'" :class="{ 'is-active': clusterOrder === 'desc' }" name="arrow_bottom" size="small" />
                    <svg-icon v-show="option.label === 'asc'" :class="{ 'is-active': clusterOrder === 'asc' }" name="arrow_top" size="small" />
                  </el-radio-button>
                </el-radio-group>
              </div>
              <div class="cluster-list">
                <div class="cluster-item" v-for="(data, i) in topClusters" :key="i">
                  <span class="breakdown-label">{{ data.key }}</span>
                  <span class="breakdown-value">{{ round(data[sortClusterBy]) }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="l-flex-column chart-block">
            <div class="chart-row">
              <div class="is-card flex-1">
                <p class="block-header">
                  Gender
                </p>
                <div v-if="optionExists('gender')" width="100" height="100" style="margin-top: 40px">
                  no gender available
                </div>
                <v-chart
                  v-else
                  class="chart-breakdown"
                  :option="getOptions('gender')"
                  autoresize
                />
              </div>
              <div class="is-card flex-1">
                <p class="block-header">
                  Age
                </p>
                <div v-if="optionExists('age')" width="100" height="100" style="margin-top: 40px">
                  no age available
                </div>
                <v-chart
                  v-else
                  class="chart-breakdown"
                  :option="getOptions('age')"
                  autoresize
                />
              </div>
            </div>
            <div class="chart-row">
              <div class="is-card flex-1">
                <p class="block-header">
                  Income
                </p>
                <div v-if="optionExists('income')" width="100" height="100" style="margin-top: 40px">
                  no income available
                </div>
                <v-chart
                  v-else
                  class="chart-breakdown"
                  :option="getOptions('income')"
                  autoresize
                />
              </div>

              <div class="is-card flex-1">
                <p class="block-header">
                  Education
                </p>
                <div v-if="optionExists('education')" width="100" height="100" style="margin-top: 40px">
                  no education available
                </div>
                <v-chart
                  v-else
                  class="chart-breakdown"
                  :option="getOptions('education')"
                  autoresize
                />
              </div>
            </div>
          </div>
        </div>
      </template>
      <div
        class="zero-data"
        v-else
      >
        <svg-icon name="empty-placeholder" size="big" />
        <p class="zero-state-message">
          No breakdown available.
        </p>
      </div>
    </template>
  </div>
</template>
<script>
import { mapState } from 'vuex'

import Spinner from '@/components/common/Spinner'
import { isEmpty, orderBy, take, cloneDeep } from 'lodash'

export default {
    components: {
        Spinner
    },

    props: {
        visible: {
            default: false,
            type: Boolean,
        }
    },

    data() {
        return {
            sortClusterBy: 'cluster_in_segment',
            clusterOrder: 'desc',
            options: {
                tooltip: {
                    trigger: 'item',
                    borderColor: 'white'
                },
                toolbox: {
                    show: true,
                    showTitle: false
                },
                legend: {
                    top: 'center',
                    left: 0,
                    orient: 'vertical',
                    show: true,
                    textStyle: {
                        fontSize: 14,
                        fontFamily: 'weborama',
                        color: '#000000'
                    },
                },
                color: ['#786AF4', '#33A6FF', '#7AABD1', '#4498E2', '#4048EF'],
                series: [
                    {
                        type: 'pie',
                        radius: ['60%', '90%'],
                        left: '55%',
                        top: 0,
                        label: {
                            show: false,
                            fontSize: 18,
                        },
                        labelLine: {
                            show: false
                        },
                        data: [],
                        itemStyle: {
                            borderWidth: '0',
                            borderColor: 'white'
                        }
                    }
                ]
            },
            optionBar: {
                label: {
                    show: true,
                    position: 'top',
                    formatter: '{c}%',
                    fontFamily: 'weborama',
                    fontSize: 16,
                    fontWeight: '400',
                },
                grid: {
                    top: 20,
                    bottom: 20
                },
                tooltip: {
                    trigger: 'item',
                    borderColor: 'white',
                    top: '0%',
                    show: false
                },
                legend: {show: false},
                xAxis: {
                    data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    }
                },
                yAxis: {
                    show: false
                },
                color: ['#786AF4', '#33A6FF', '#7AABD1', '#4498E2', '#4048EF'],
                series: [{
                    name: 'Sale',
                    type: 'bar',
                    data: [{value: 5}, 20, 36, 10, 10, 20, 4],
                    barWidth: 7,
                    itemStyle: {
                        borderRadius: [5, 5, 5, 5]
                    }
                }]
            },
            tabActive: 'gender',

            ageLegend: {
                'Aged 18 to 24': {
                    color:'#4498E2',
                    name: '18-24'
                },
                'Aged 25 to 34': {
                    color:'#4048EF',
                    name: '25-34'
                },
                'Aged 35 to 49': {
                    color:'#2DC9EB',
                    name: '35-49'
                },
                'Aged 50 to 64': {
                    color:'#809FB8',
                    name: '50-64'
                },
                'Aged 65 and more': {
                    color:'#645AFF',
                    name: '65+'
                }
            },
            localLoading: true
        }
    },

    computed: {
        ...mapState('builder', {
            breakdown: state => state.formulaBreakdown,
            isLoading: state => state.formulaBreakdownLoading,
        }),

        haveData() {
            return !!this.breakdown
        },

        topClusters() {
            return this.getTopClusters({ topNumber: 20, sortItem: this.sortClusterBy, sort: this.clusterOrder })
        },
    },

    methods: {
        round(data) {
            return Math.round(data * 100) / 100
        },

        getTopClusters({ topNumber, sortItem, sort = [ 'desc', 'asc'] }) {
            const clusters = []
            const _clusters = this.breakdown?.clusters ?? {}

            if (isEmpty(_clusters)) return []

            for (const key in _clusters) {
                const cluster = _clusters[key]
                if (!isEmpty(cluster)) clusters.push({ ...cluster, key })
            }

            //sort by sortItem descdending order, if same sortItem value, alphabetical order
            const sortedClusters = orderBy(clusters, [sortItem, 'key'], sort)

            //return top clusters
            return take(sortedClusters, topNumber)
        },

        optionExists(category) {
            return !this.breakdown?.[category]
        },

        generateOptions(category) {
            if (!this.breakdown?.age) {
                return
            }
            if(category === 'age') {
                this.optionBar.series[0].data = Object.keys(this.breakdown.age).map((key) => {
                    const fragment = this.breakdown.age[key]
                    return {
                        name: this.ageLegend[key].name,
                        value: Math.round(fragment.volume),
                        tooltip: {
                            trigger: 'item',
                            formatter: '<div class="content-tooltip"><span>{b} : </span><span class="tooltip-value">{c} %</span></div>',
                            borderColor: 'white'
                        },
                        itemStyle: {
                            color: this.ageLegend[key].color
                        }
                    }
                })
                this.optionBar.xAxis.data = Object.keys(this.breakdown.age).map((key) => this.ageLegend[key].name)

                return this.optionBar
            }

            const currentData = this.breakdown[category]
            if (currentData) {
                const _options = cloneDeep(this.options)
                _options.series[0].data = Object.keys(currentData).map((key) => {
                    return {
                        value: Math.round(currentData[key].volume),
                        name: key,
                        tooltip: {
                            trigger: 'item',
                            formatter: this.getChartTooltip(key, category),
                            borderColor: 'white'
                        }
                    }
                })

                if(category === 'gender') {
                    _options.series[0].itemStyle.borderWidth = '0'
                }

                _options.series[0].itemStyle.borderWidth = '2'
                return _options
            }
            return {}
        },

        getChartTooltip(key, tab) {
            if (tab === 'gender') {
                return `<div class="content-tooltip is-gender"><span class="tooltip-gender ${key.toLowerCase()}"></span><span class="tooltip-value">{c} %</span></div>`
            }

            return '<div class="content-tooltip"><span>{b} : </span><span class="tooltip-value">{c} %</span></div>'
        },

        getOptions(category) {
            return this.generateOptions(category)
        },
    },

    watch: {
        isLoading(val) {
            if (!val) this.localLoading = val
        },

        visible(val) {
            if (!val) this.localLoading = true
        }
    },
}
</script>
<style lang="scss">
.breakdown.builder-page {
  min-height: 660px;
  padding: 20px 20px 0 20px;
  display: flex;
  align-items: center;
  &.justify-center {
    justify-content: center;
  }
  .block-header {
    margin-bottom: 20px;
    font-size: 1.2rem;
    color: black;
    font-weight: 500;
  }
  .chart-container {
    gap: 20px;
    width: 100%;
  }
  .breakdown-section {
    margin: 0;
  }
  .cluster-sort {
    .el-radio-button__inner {
      padding: 2px 5px;
      line-height: 0;
      .is-active {
        svg {
          fill: white
        }
      }
    }
  }
  .chart-breakdown {
    height: 200px;
  }

  .tabs-breakdown {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;

    .tab {
      font-size: 12px;
      cursor: pointer;
      filter: opacity(0.5);

      &.active {
        font-weight: 500;
        filter: unset;
      }

      &:before {
        content: '';
        height: 9px;
        width: 9px;
        display: inline-block;
        background-color: #53A8E2;
        border-radius: 100%;
      }
    }

  }
  .spinner-wrapper {
    margin-top: 0;
    text-align: center;
  }
  .zero-data {
    height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-size: 18px;
    margin-top: -40px;
    p {
      margin-top: 10px;
    }
  }

  .content-tooltip {
    &:not(.is-gender) {
      .tooltip-value {
        font-size: 1.2rem;
        font-weight: 500;
        margin-left: 5px;
      }
    }
  }
  .chart-block {
    width: 75%;
    gap: 20px;
    .chart-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      gap: 20px;
    }
  }
}
</style>
